import localforage from "localforage";
import { apiUrl, apiNewVersion } from "../../config";

import digestMessage from "./utilities/digestMessage";
import hexString from "./utilities/hexString";

export async function editUser (
    userId,
    user
) {
    const token = await localforage.getItem("339vending.admin-token");
    const body = new FormData();
    for (const key in user) {
        if (key === "avatar") {
            if (user["avatar"]) {
                body.append("avatar", user["avatar"])
            }
        } else if (key === "password") {
            if (user["password"]) {
                body.append(
                    key,
                    JSON.stringify(hexString(await digestMessage(user["password"])))
                );
            }
        } else if (user[key] !== undefined && user[key] !== null) {
            body.append(key, JSON.stringify(user[key]));
        }
    }
    const response = await fetch(
        `${ apiUrl }/${ apiNewVersion }/user/${ userId }`,
        {
            method: "PATCH",
            mode: "cors",
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${ token }`
            },
            body,
        }
    );

    if (response.ok) {
        const user = await response.json();
        if (user) {
            return user;
        }
        throw "Register error";
    }

    if (response.status >= 400) {
        throw await response.text();
    }

    throw "Internal server error";
}

export default editUser;
